import { SmileIcon } from '$components'
import { FormFieldGroup, FormGroup, FormLabel, FormSelect, FormInput, Text, Option, Button } from '$components'
import { useFormContext } from 'react-hook-form'
import { CreateAppointmentSchema, Input, useCreateAppointmentForm } from '.'
import { useInfiniteClientOptions } from '$hooks/use-infinite-client-options'

export function ClientSection() {
  const { setValue, watch } = useFormContext<CreateAppointmentSchema>()
  const { setClientId } = useCreateAppointmentForm()
  const createNewClient = watch(Input._NewClient)

  const clientOptions = useInfiniteClientOptions()

  return (
    <FormGroup label="Client Information">
      {createNewClient && (
        <div className="flex items-center justify-between">
          <Text
            as="h4"
            type="s"
            weight="medium"
          >
            Create New Client
          </Text>
          <Button
            type="button"
            size="sm"
            variant="secondary"
            onClick={() => {
              setValue(Input._NewClient, false)
              setValue(Input.Client, null!)
              setValue(Input.Pet, null!)
              setValue(Input._NewPet, false)
              setClientId(undefined)
            }}
          >
            Select Existing
          </Button>
        </div>
      )}

      { createNewClient && (
        <div className="space-y-4 p-6 bg-neutral-50 rounded-2xl">
          <div className="grid grid-cols-2 gap-4">
            <FormFieldGroup>
              <FormLabel htmlFor={Input.NewClientFirstName}>
                First Name
              </FormLabel>
              <FormInput
                name={Input.NewClientFirstName}
                placeholder="First name"
              />
            </FormFieldGroup>

            <FormFieldGroup>
              <FormLabel htmlFor={Input.NewClientLastName}>
                Last Name
              </FormLabel>
              <FormInput
                name={Input.NewClientLastName}
                placeholder="Last name"
              />
            </FormFieldGroup>
          </div>

          <FormFieldGroup>
            <FormLabel htmlFor={Input.NewClientEmail}>
              Email
            </FormLabel>
            <FormInput
              name={Input.NewClientEmail}
              type="email"
              placeholder="Email address"
            />
          </FormFieldGroup>

          <FormFieldGroup>
            <FormLabel htmlFor={Input.NewClientPhone}>
              Phone Number
            </FormLabel>
            <FormInput
              name={Input.NewClientPhone}
              placeholder="Phone number"
            />
          </FormFieldGroup>
        </div>
      )}

      {!createNewClient && (
        <FormFieldGroup className="flex-1">
          <FormLabel htmlFor={Input.Client}>
            Client
          </FormLabel>

          <div className="flex items-center gap-4">
            <FormSelect
              name={Input.Client}
              placeholder="Select a client"
              icon={SmileIcon}
              {...clientOptions}
              onChange={(value) => {
                setClientId(value ? (value as Option).id as number : undefined)
                setValue(Input.Pet, null!)
                setValue(Input._NewPet, false)
              }}
            />

            <Button
              type="button"
              variant="secondary"
              onClick={() => {
                setValue(Input._NewClient, true)
                setValue(Input.Client, null!)
                setValue(Input.Pet, null!)
                setValue(Input._NewPet, true)
                setClientId(1) // Temporary ID to enable pet functionality
              }}
            >
              New Client
            </Button>
          </div>
        </FormFieldGroup>
      )}
    </FormGroup>
  )
}
